import type { ReactNode } from 'react'
import type {
  ElitePlansPriceBasedOfferDisplay,
  ElitePlansTenureBasedOfferDisplay
} from '../../../elitePlansPrimaryCtaDisplay'
import { PlanTopBannerTwoLineStrip } from '../../../../new-elite-landing/components/NewEliteLandingPlanSelector'
import { ElitePlansPrimaryCta, type ElitePlansPrimaryCtaProps } from './ElitePlansPrimaryCta'

const ELITE_PRIME_OFFER_BANNER_BACKGROUND =
  'linear-gradient(86deg, rgba(255, 198, 208, 0.60) -44.71%, rgba(255, 177, 190, 0.60) 139.07%)'

type ElitePlansHeroPrimaryCtaProps = ElitePlansPrimaryCtaProps & {
  priceBasedOffer: ElitePlansPriceBasedOfferDisplay | null
  tenureBasedOffer: ElitePlansTenureBasedOfferDisplay | null
  familyBlockedNote: string
}

export function ElitePlansHeroPrimaryCta({
  priceBasedOffer,
  tenureBasedOffer,
  familyBlockedNote,
  ...ctaProps
}: ElitePlansHeroPrimaryCtaProps) {
  // Primary not Elite/Prime: note + disabled Upgrade CTA (matches familyEliteLandingPageStateConfig isDisabled)
  if (familyBlockedNote) {
    return (
      <div
        className='mt-8 w-full overflow-hidden rounded-xl bg-white/60 text-center'
        data-testid='elite-plans-family-blocked-cta'
      >
        <p className='px-5 py-3 text-13 leading-[1.5] font-medium text-prime70'>
          {familyBlockedNote}
        </p>
        <ElitePlansPrimaryCta {...ctaProps} disabled className='' />
      </div>
    )
  }
  if (priceBasedOffer) {
    return (
      <PrimaryCtaOfferBanner
        {...ctaProps}
        testId='elite-plans-price-based-cta'
        offerText={
          <>
            Get extra <span className='font-semibold'>{priceBasedOffer.percentOff}%</span> off for a
            limited time
          </>
        }
      />
    )
  }
  if (tenureBasedOffer) {
    return (
      <PrimaryCtaOfferBanner
        {...ctaProps}
        testId='elite-plans-tenure-based-cta'
        eyebrow='LIMITED TIME OFFER'
        offerText={tenureBasedOffer.offerText}
        offerTextClassName='font-medium'
      />
    )
  }
  return <ElitePlansPrimaryCta {...ctaProps} />
}

function PrimaryCtaOfferBanner({
  offerText,
  eyebrow,
  offerTextClassName,
  testId,
  className = 'mt-8',
  ...ctaProps
}: ElitePlansPrimaryCtaProps & {
  offerText: ReactNode
  eyebrow?: ReactNode
  offerTextClassName?: string
  testId?: string
}) {
  return (
    <div
      className={`w-full overflow-hidden rounded-xl text-center text-[#65321D] ${className}`}
      style={{ background: ELITE_PRIME_OFFER_BANNER_BACKGROUND }}
      data-testid={testId}
    >
      <PlanTopBannerTwoLineStrip
        isSelected={false}
        headline={eyebrow}
        subline={offerText}
        sublineClassName={offerTextClassName}
      />
      <ElitePlansPrimaryCta {...ctaProps} className='' />
    </div>
  )
}
